import React, { useEffect, useRef, useState } from 'react';
import mapboxgl from 'mapbox-gl';
import 'mapbox-gl/dist/mapbox-gl.css';
import mapboxSdk from '@mapbox/mapbox-sdk';
import mbxGeocoding from '@mapbox/mapbox-sdk/services/geocoding';
import ListView from './MarkerListView'
import logo from './PKC_Logo_Small.JPG';
import mapMarker from './PKC_Map_Marker_75.png';

function Home(props) {
    const mapContainerRef = useRef();
    const mapRef = useRef();
    const geocodingClientRef = useRef();
    const [countyGeoJson, setCountyGeoJson] = useState(null);
    const [stateGeoJson, setStateGeoJson] = useState(null);
    const [eventData, setEventData] = useState(null);
    const [config, setConfig] = useState(null);
    const [query, setQuery] = useState('');
    const [results, setResults] = useState(null);
    const [baseEventResults, setBaseEventResults] = useState(null);
    const [selectedCounty, setSelectedCounty] = useState(null);
    const [selectedCountyId, setSelectedCountyId] = useState(null);
    const [onClear, setOnClear] = useState(false);
    const selectedCountyIdRef = useRef(null);

    const originalBounds = [
        [-109.04503689386989, 37.0021309434908],
        [-102.05181504519271, 41.00284889412739],
    ]

    const setEventDataFromFilter = (eventsfiltered) => {
        eventsfiltered.type = 'FeatureCollection';
        setEventData(eventsfiltered);
    };

    const handleItemClick = (item) => {
        console.log('Clicked:', item);


        if (!mapRef.current || !item) return;

        mapRef.current.flyTo({
            center: item.geometry.coordinates,
            zoom: 10
        });

    };

    const onClearClick = () => {
        if (!mapRef.current) return;

        mapRef.current.fitBounds(originalBounds, {
            padding: 20,
            duration: 1000,
        });

        setEventData(baseEventResults);
        setSelectedCountyId(null)
    };

    const handleSearch = async () => {
        try {
            const response = await geocodingClientRef.current
                .forwardGeocode({
                    query,
                    limit: 1,
                })
                .send();

            const match = response.body.features[0];

            //here we need to set filter on the list view, but we need to use coordinates

            setResults(match);
            console.log('Geocoded result:', match);
        } catch (error) {
            console.error('Geocoding error:', error);
        }
    };


    useEffect(() => {
        const fetchConfig = async () => {
            const response = await fetch('config');
            const result = await response.text(); // Await the JSON parsing
            setConfig(result);
        }

        fetchConfig();
    }, []);


    useEffect(() => {

        if (!config) return; // Initialize map only once

        mapboxgl.accessToken = config;
        mapRef.current = new mapboxgl.Map({
            container: mapContainerRef.current,
            style: 'mapbox://styles/mapbox/streets-v11',
            config: {
                basemap: {
                    theme: 'monochrome'
                }
            },
            //center: [-106.1063329, 37.751663],
            //zoom: 6
            bounds: originalBounds, // bounding box (southwest corner, northeast corner)
            // by setting the bounds your map will automatically center around the bounding box
            fitBoundsOptions: {
                padding: 15 // padding to keep the bounds away from the edge of the map
            },
        });

        const mapboxClient = mapboxSdk({ accessToken: mapboxgl.accessToken });
        geocodingClientRef.current = mbxGeocoding(mapboxClient);

        mapRef.current.on('load', () => {
            const fetchCountyGeoJSON = async () => {
                const response = await fetch('countiesgeojson');
                const result = await response.json(); // Await the JSON parsing
                setCountyGeoJson(result);
            }

            const fetchStateGeoJSON = async () => {
                const response = await fetch('stategeojson');
                const result = await response.json(); // Await the JSON parsing
                setStateGeoJson(result);
            }

            const fetchEventData = async () => {
                const response = await fetch('events');
                const result = await response.json(); // Await the JSON parsing
                setEventData(result);
                setBaseEventResults(result);
            }

            fetchCountyGeoJSON();
            fetchStateGeoJSON();
            fetchEventData();
        });
    }, [config]);

    useEffect(() => {
        if (!mapRef.current || !countyGeoJson) return;

        let hoveredPolygonId = null;

        if (mapRef.current.getSource('counties')) {
            mapRef.current.getSource('counties').setData(countyGeoJson);
        } else {
            mapRef.current.addSource('counties', {
                type: 'geojson',
                data: countyGeoJson
            });
            mapRef.current.addLayer({
                id: 'county-fills',
                type: 'fill',
                source: 'counties',
                paint: {
                    'fill-color': '#094877',
                    'fill-opacity': [
                        'case',
                        ['boolean', ['feature-state', 'hover'], false],
                        .7,
                        0.2
                    ]
                }
            });

            mapRef.current.addLayer({
                id: 'county-borders',
                type: 'line',
                source: 'counties',
                layout: {},
                paint: {
                    'line-color': '#A5A4A4',
                    'line-width': 1
                }
            });

            mapRef.current.on('mousemove', 'county-fills', (e) => {
                if (e.features.length > 0) {
                    if (hoveredPolygonId !== null) {
                        mapRef.current.setFeatureState(
                            { source: 'counties', id: hoveredPolygonId },
                            { hover: false }
                        );
                    }
                    hoveredPolygonId = e.features[0].id;
                    mapRef.current.setFeatureState(
                        { source: 'counties', id: hoveredPolygonId },
                        { hover: true }
                    );
                }
            });

            mapRef.current.on('mouseenter', 'county-fills', () => {
                mapRef.current.getCanvas().style.cursor = 'pointer';
            })

            mapRef.current.on('mouseleave', 'county-fills', () => {
                if (hoveredPolygonId !== null) {
                    mapRef.current.setFeatureState(
                        { source: 'counties', id: hoveredPolygonId },
                        { hover: false }
                    );
                }
                hoveredPolygonId = null;

                mapRef.current.getCanvas().style.cursor = '';
            });

            mapRef.current.on('load', () => {
                mapRef.current.loadImage(mapMarker, (error, image) => {
                    if (error) throw error;
                    if (!mapRef.current.hasImage('pkc-icon')) {
                        mapRef.current.addImage('pkc-icon', image);
                    }

                });
            });


            mapRef.current.on('click', 'county-fills', (e) => {

                mapRef.current.flyTo({
                    center: e.lngLat,
                    zoom: 7
                });

                const clickedFeature = e.features[0];
                const clickedName = clickedFeature.properties.name;
                const currentCountyName = selectedCountyIdRef.current;

                if (clickedName === currentCountyName) {
                    if (!mapRef.current) return;

                    mapRef.current.fitBounds(originalBounds, {
                        padding: 20,
                        duration: 1000,
                    });

                    setEventData(baseEventResults);
                    setOnClear(true);
                    return;
                }

                setOnClear(false);
                setSelectedCountyId(e.features[0].properties.name);
                setSelectedCounty(e.features[0].geometry);
            });
        }
    }, [countyGeoJson]); // Re-run effect when geoJsonData changes


    useEffect(() => {
        selectedCountyIdRef.current = selectedCountyId;
    }, [selectedCountyId]);


    useEffect(() => {
        if (!mapRef.current || !stateGeoJson) return;

        if (mapRef.current.getSource('state')) {
            mapRef.current.getSource('state').setData(stateGeoJson);
        } else {
            mapRef.current.addSource('state', {
                type: 'geojson',
                data: stateGeoJson
            });

            mapRef.current.addLayer({
                id: 'line-bounding-box',
                type: 'line',
                paint: {
                    'line-color': '#094877',
                    'line-width': 3,
                    'line-opacity': 0.9
                },
                source: 'state'
            });

        }
    }, [stateGeoJson]);

    useEffect(() => {
        if (!mapRef.current || !eventData) return;

        //mapMarker

        const addLayer = () => {

            // instead of dynamically adding markers, we will get GeoJson from the BE and set source
            if (mapRef.current.getSource('event-markers')) {
                mapRef.current.getSource('event-markers').setData(eventData);
            } else {

                mapRef.current.addSource('event-markers', {
                    type: 'geojson',
                    data: eventData
                });

                mapRef.current.loadImage(mapMarker, (error, image) => {
                    if (error) throw error;
                    if (!mapRef.current.hasImage('pkc-icon')) {
                        mapRef.current.addImage('pkc-icon', image);
                    }

                });

                mapRef.current.addLayer({
                    id: 'event-markers-layer',
                    type: 'symbol',
                    source: 'event-markers',
                    layout: {
                        'icon-image': 'pkc-icon',
                        'icon-size': 0.5,
                        'icon-allow-overlap': true,
                        'text-field': ['get', 'title'],
                        'text-offset': [0, 1.5],
                        'text-anchor': 'top',
                    },
                    paint: {
                        'text-color': '#000000',
                    },
                });

                mapRef.current.moveLayer('event-markers-layer');
            }
        };

        if (mapRef.current.isStyleLoaded()) {
            addLayer();
        } else {
            mapRef.current.once('idle', addLayer);
        }


    }, [eventData]);

    return (
        <div>
            <div className="dashboard-container">
                <div className="list-panel">
                    <div className="list-header">
                        <img src={logo} alt="Logo" className="header-logo" />
                        <h2 className="header-title">PKC - Upcoming Events</h2>
                    </div>
                    <ListView onClearFromParent={onClear} selectedCounty={selectedCounty} setEventDataFromFilter={setEventDataFromFilter} items={baseEventResults} onItemClick={handleItemClick} map={mapRef.current} config={config} onClearClick={onClearClick} />
                </div>
                <div className="map-panel">
                    <div ref={mapContainerRef} id="map" style={{ height: '100%' }}></div>
                </div>
            </div>
        </div>
    );

}

export default Home;